import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
    providedIn: 'root'
})
export class OcorrenciaDBService extends DatabaseService {
    override classname: string = 'OcorrenciaDBService';
    override table = 'ocorrencia';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}
